import React from "react";
import { Link } from "react-router-dom";
import styles from "./Terms.module.scss";

const Terms: React.FC = () => {
  return (
    <div className={styles.termsPage}>
      <div className={styles.container}>
        <header className={styles.header}>
          <Link to="/" className={styles.brand}>
            <span className={styles.cursive}>Hippocampus Gaming</span>
          </Link>
        </header>

        <article className={styles.content}>
          <h1>Terms of Service</h1>
          <p className={styles.lastUpdated}>Last Updated: August 6, 2026</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By creating an account or using Hippocampus Gaming, you agree to be
              bound by these Terms of Service. If you do not agree to these
              terms, you may not use the platform.
            </p>
          </section>

          <section>
            <h2>2. Eligibility</h2>
            <p>
              You must be at least 13 years of age to create an account and use
              Hippocampus Gaming. By registering, you represent that you meet
              this minimum age requirement.
            </p>
          </section>

          <section>
            <h2>3. Account Responsibilities</h2>
            <ul>
              <li>
                You are responsible for maintaining the security of your account
                credentials.
              </li>
              <li>
                You are responsible for all activity that occurs under your
                account.
              </li>
              <li>
                You must provide accurate information during registration,
                including your date of birth.
              </li>
              <li>
                You may not create multiple accounts or share your account with
                others.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Acceptable Use</h2>
            <p>When using Hippocampus Gaming, you agree not to:</p>
            <ul>
              <li>Harass, bully, or threaten other users</li>
              <li>Post illegal, harmful, or offensive content</li>
              <li>Impersonate other users or entities</li>
              <li>Attempt to exploit or disrupt the platform</li>
              <li>Use automated tools to scrape or interact with the platform</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section>
            <h2>5. User Content</h2>
            <p>
              You retain ownership of content you post on Hippocampus Gaming.
              However, by posting content, you grant us a non-exclusive,
              worldwide license to display and distribute that content within the
              platform.
            </p>
            <p>
              We reserve the right to remove content that violates these terms or
              our community guidelines.
            </p>
          </section>

          <section>
            <h2>6. Linked Accounts</h2>
            <p>
              You may link external gaming accounts (Steam, Discord, Epic Games,
              etc.) to your Hippocampus Gaming profile. By linking an account,
              you authorize us to access limited information from that platform
              as described in our{" "}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </section>

          <section>
            <h2>7. Termination</h2>
            <p>
              We may suspend or terminate your account if you violate these
              terms. You may also delete your account at any time by contacting
              us.
            </p>
          </section>

          <section>
            <h2>8. Disclaimers</h2>
            <p>
              Hippocampus Gaming is provided &ldquo;as is&rdquo; without
              warranties of any kind. We do not guarantee uninterrupted access or
              that the platform will be free of errors.
            </p>
          </section>

          <section>
            <h2>9. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Continued
              use of Hippocampus Gaming after changes constitutes acceptance of
              the updated terms.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              For questions about these terms, contact us at:{" "}
              <a href="mailto:support@hippocampusgaming.com">
                support@hippocampusgaming.com
              </a>
            </p>
          </section>
        </article>

        <footer className={styles.footer}>
          <p>&copy; 2026 Hippocampus Gaming. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Terms;
